
import _ from 'lodash';
import ResetDcoConfig from './reset-dco-config.vue';

export default {
  components: {
    ResetDcoConfig: ResetDcoConfig
  },

  props: {
    config: {
      type: Object,
      required: true
    },
    resettable: {
      type: Boolean,
      required: true
    },
    isDefault: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    capitalize: _.capitalize
  }
};